import { Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-print-name-list',
  templateUrl: './print-name-list.component.html',
  styleUrls: ['./print-name-list.component.scss']
})
export class PrintNameListComponent implements OnInit {

  @Input() printNames: any[] = [];
  @Input() data: any;  
  @Output() itemSelected = new EventEmitter<any>();
  
  constructor() { }

  ngOnInit() {
  }


  selectItem(item: any) {
    this.itemSelected.emit({ item, data: this.data });
  }

}
